
    import { Component, Prop, Vue } from 'vue-property-decorator';

    type TableRow = {
        fw_created_user?: string | null;
        fw_created_time?: string | null;
        fw_modified_user?: string | null;
        fw_modified_time?: string | null;
    }

    @Component
    export default class Timestamp extends Vue {
        @Prop({ default: () => ({}) }) public value!: TableRow;
        @Prop({ default: () => 'Eingetragen' }) public eingetragenText!: string;
        @Prop({ default: () => 'Geändert' }) public geaendertText!: string;
        @Prop({ default: () => true }) public padded!: boolean;
    }
